import { Calendar1 } from 'lucide-react'
import { BillingPackage } from '../../Packages/types/BillingPackage';
import { Download } from 'lucide-react';

interface PaymentsHeaderProps {
    activeTab: string;
    setActiveTab: (tab: string) => void;
    selectedService: string;
    setSelectedService: (service: string) => void;
    packages: BillingPackage[];
    selectedPackage: string;
    setSelectedPackage: (packageName: string) => void;
    gateways: string[];
    selectedGateway: string;
    setSelectedGateway: (gateway: string) => void;
    onExport: () => void; 
}

export default function PaymentsHeader({ activeTab, setActiveTab, setSelectedService, packages, selectedPackage, setSelectedPackage, gateways, selectedGateway, setSelectedGateway, onExport }: PaymentsHeaderProps) {
    const handleTabClick = (tab: string) => {
        setActiveTab(tab);
    };

    return (
        <div className="w-full flex flex-col items-start justify-start">
            <div className="flex items-center gap-x-6">
                <nav className="flex text-white text-sm">
                    <ul className="flex gap-x-6">
                        <li
                            className={`cursor-pointer ${activeTab === 'All' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('All')}
                        >
                            All
                        </li>
                        <li
                            className={`cursor-pointer ${activeTab === 'COMPLETED' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('COMPLETED')}
                        >
                            Successful
                        </li>
                        <li
                            className={`cursor-pointer ${activeTab === 'PENDING' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('PENDING')}
                        >
                            Pending
                        </li>
                        <li
                            className={`cursor-pointer ${activeTab === 'FAILED' ? 'font-bold text-white' : 'text-gray-500'}`}
                            onClick={() => handleTabClick('FAILED')}
                        >
                            Failed
                        </li>
                    </ul>
                </nav>
            </div>

            <div className="w-full flex items-center justify-between my-3">
                <div className="flex items-center gap-x-4">
                    <div className="relative">
                        <select className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700" onChange={(e) => setSelectedService(e.target.value)}>
                            <option value="All">All Services</option>
                            <option value="kanema">Kanema Online</option>
                            <option value="mingoli">Mingoli</option>
                            <option value="katswiri">Katswiri</option>
                            <option value="nkhani">Nkhani</option>
                        </select>
                    </div>

                    <div className="relative">
                        <select
                            className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700"
                            value={selectedPackage}
                            onChange={(e) => setSelectedPackage(e.target.value)}
                        >
                            <option value="All">All Packages</option>
                            {packages.map((pkg, index) => (
                                <option key={index} value={pkg.name}>
                                    {pkg.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="relative">
                        <select
                            className="w-40 h-8 px-3 py-1 rounded-md border border-gray-400 bg-white text-xs text-gray-700"
                            value={selectedGateway}
                            onChange={(e) => setSelectedGateway(e.target.value)}
                        >
                            <option value="All">All Gateways</option>
                            {gateways.map((gateway, index) => (
                                <option key={index} value={gateway}>
                                    {gateway}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* <button className='w-fit flex items-center justify-center gap-x-1 bg-white rounded-md px-2 py-2 text-gray-700 text-xs'>
                        <p>Start Day</p>
                        <Calendar1 size={14} />
                        <p>End Day</p>
                        <Calendar1 size={14} />
                    </button> */}
                </div>

                <button className='w-fit flex items-center justify-center gap-x-1 bg-white rounded-md px-3 py-2 text-gray-700 text-xs hover:scale-105 transition-all cursor-pointer'
                onClick={onExport}>
                    <Download size={14} />
                    Export
                </button>
            </div>

        </div>
    )
}